
import React, { useState, useEffect } from 'react';
// Fix: Import Page type from correct location
import { Page } from '../types';

interface StickyCTAProps {
  navigate: (page: Page) => void;
}

const StickyCTA: React.FC<StickyCTAProps> = ({ navigate }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="lg:hidden fixed bottom-6 left-0 right-0 px-6 z-40 animate-slide-up">
      <button 
        // Changed from 'download' to 'warteliste' to match the Page type definition
        onClick={() => navigate('warteliste')}
        className="w-full bg-primary text-white py-4 rounded-2xl font-black text-lg shadow-[0_10px_30px_rgba(238,34,59,0.3)] active:scale-95 transition-all flex items-center justify-center gap-3 min-h-[48px]"
      >
        <span>Warteliste beitreten</span>
        <span className="text-xl">🚀</span>
      </button>
    </div>
  );
};

export default StickyCTA;
